const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

let started = false;
let currentConfig = null;

export function register(config) {
  currentConfig = config;

  if (!('serviceWorker' in navigator)) {
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    if (isLocalhost) {
      registerDevPushSW();
    }
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  const startRegistration = () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl);
      navigator.serviceWorker.ready.then(() => {
        console.log(
          'This web app is being served cache-first by a service ' +
            'worker. To learn more, visit https://cra.link/PWA'
        );
      });
      return;
    }

    registerValidSW(swUrl);
  };

  if (document.readyState === 'complete') {
    startRegistration();
  } else {
    window.addEventListener('load', startRegistration);
  }
}

function notifyWaiting(registration) {
  if (registration.waiting && currentConfig && currentConfig.onUpdate) {
    currentConfig.onUpdate(registration);
  }
}

function watchForUpdates(registration) {
  if (registration.waiting && navigator.serviceWorker.controller) {
    notifyWaiting(registration);
  }

  registration.addEventListener('updatefound', () => {
    const installingWorker = registration.installing;
    if (installingWorker == null) {
      return;
    }

    installingWorker.addEventListener('statechange', () => {
      if (installingWorker.state !== 'installed') {
        return;
      }

      if (navigator.serviceWorker.controller) {
        notifyWaiting(registration);
        return;
      }

      if (currentConfig && currentConfig.onSuccess) {
        currentConfig.onSuccess(registration);
      }
    });
  });

  const checkForUpdate = () => {
    if (document.visibilityState !== 'visible') {
      return;
    }
    registration.update().then(() => {
      notifyWaiting(registration);
    }).catch(() => {});
  };

  document.addEventListener('visibilitychange', checkForUpdate);
  setInterval(checkForUpdate, 60 * 1000);
  checkForUpdate();
}

function registerDevPushSW() {
  if (started) {
    return;
  }
  started = true;

  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/dev-push-sw.js`, { updateViaCache: 'none' })
    .catch((error) => {
      started = false;
      console.error('Error during dev push service worker registration:', error);
    });
}

function registerValidSW(swUrl) {
  if (started) {
    return;
  }
  started = true;

  navigator.serviceWorker
    .register(swUrl, { updateViaCache: 'none' })
    .then((registration) => {
      watchForUpdates(registration);
    })
    .catch((error) => {
      started = false;
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
    cache: 'no-store',
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
